import type { AloftPrice, ProductColor } from '@aloft/toolkit-shared';

export const getColorFromAdjustment = (adjustment?: AloftPrice): ProductColor => {
  if (!adjustment) return 'textPrimary';

  const numeric = adjustment.toNumericPrice();

  return numeric > 0 ? 'alertSuccess' : 'alertError';
};
